import { TEmblaSliderElement } from "./types";
import useEmblaSlider from "./useEmblaSlider";

const EmblaSliderViewport: React.FC<TEmblaSliderElement> = ({
  children,
  className = "Embla-Slider-viewport",
  id,
}) => {
  const [emblaRef] = useEmblaSlider()!;
  return (
    <div
      id={id ? `${id}_embla_slider_viewport` : undefined}
      ref={emblaRef}
      className={className}
    >
      {children}
    </div>
  );
};

export default EmblaSliderViewport;
